import Vue from 'vue'
import FaultCodes from './FaultCodes.vue'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'

window.vm = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(FaultCodes)
}).$mount('#faultcodes')
